import { ColumnHeader, ColumnDisplay, ColumnExtensions, ColumnData } from "./datatable.models";

export interface Column
	extends ColumnHeader,
	ColumnDisplay,
	ColumnExtensions,
	ColumnData {
	main?: boolean;
	noneditable?: boolean;
	isMandatory?: boolean;
	template?;
}
